(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 17);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function mustBeString(str, o) {
    if (typeof str !== "string")
        throw new Error("Expected to be string: " + JSON.stringify(o ? o : str));
    return str;
}
exports.mustBeString = mustBeString;
function mustBeDefined(t, o) {
    if (t === undefined)
        throw new Error("Expected to be defined: " + JSON.stringify(o ? o : t));
    return t;
}
exports.mustBeDefined = mustBeDefined;
function mustBeArray(str, o) {
    if (!isArray(str))
        throw new Error("Expected to be array: " + JSON.stringify(o ? o : str));
    return str;
}
exports.mustBeArray = mustBeArray;
function isArray(data) {
    return !!data && data.constructor === Array;
}
exports.isArray = isArray;
function isNumber(data) {
    return typeof data === "number";
}
exports.isNumber = isNumber;
function isString(data) {
    return typeof data === "string";
}
exports.isString = isString;
exports.flattenMyArray = function (arr, result) {
    if (!result)
        result = [];
    for (var i = 0, length = arr.length; i < length; i++) {
        var value = arr[i];
        if (Array.isArray(value)) {
            for (var i_1 = 0, length_1 = value.length; i_1 < length_1; i_1++) {
                var value2 = value[i_1];
                if (Array.isArray(value2)) {
                    exports.flattenMyArray(value2, result);
                }
                else {
                    result.push(value2);
                }
            }
        }
        else {
            result.push(value);
        }
    }
    return result;
};


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BibStringComponent_1 = __webpack_require__(4);
var QuotedString = (function (_super) {
    __extends(QuotedString, _super);
    function QuotedString(braceDepth, data) {
        return _super.call(this, "quotedstring", braceDepth, data) || this;
    }
    return QuotedString;
}(BibStringComponent_1.BibStringComponent));
exports.QuotedString = QuotedString;
var OuterQuotedString = (function (_super) {
    __extends(OuterQuotedString, _super);
    function OuterQuotedString(data) {
        return _super.call(this, "quotedstringwrapper", data) || this;
    }
    return OuterQuotedString;
}(BibStringComponent_1.BibOuterStringComponent));
exports.OuterQuotedString = OuterQuotedString;
function isOuterQuotedString(x) {
    return x.type === "quotedstringwrapper";
}
exports.isOuterQuotedString = isOuterQuotedString;
function isQuotedString(x) {
    return x.type === "quotedstring";
}
exports.isQuotedString = isQuotedString;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BibStringComponent_1 = __webpack_require__(4);
var BracedString = (function (_super) {
    __extends(BracedString, _super);
    function BracedString(braceDepth, data) {
        var _this = _super.call(this, "bracedstring", braceDepth, data) || this;
        _this.isSpecialCharacter = braceDepth === 0 && data[0] === "\\";
        return _this;
    }
    return BracedString;
}(BibStringComponent_1.BibStringComponent));
exports.BracedString = BracedString;
var OuterBracedString = (function (_super) {
    __extends(OuterBracedString, _super);
    function OuterBracedString(data) {
        return _super.call(this, "bracedstringwrapper", data) || this;
    }
    return OuterBracedString;
}(BibStringComponent_1.BibOuterStringComponent));
exports.OuterBracedString = OuterBracedString;
function isOuterBracedString(x) {
    return x.type === "bracedstringwrapper";
}
exports.isOuterBracedString = isOuterBracedString;
function isBracedString(x) {
    return x.type === "bracedstring";
}
exports.isBracedString = isBracedString;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var StringRef_1 = __webpack_require__(5);
var BracedString_1 = __webpack_require__(2);
var QuotedString_1 = __webpack_require__(1);
var util_1 = __webpack_require__(0);
function isBibStringComponent(x) {
    return typeof x.braceDepth === "number" && typeof x.type === "string";
}
exports.isBibStringComponent = isBibStringComponent;
function isContiguousSimpleString(x) {
    return x.type === "ContiguousSimpleString" && util_1.isArray(x.data);
}
exports.isContiguousSimpleString = isContiguousSimpleString;
function joinContiguousSimpleStrings(x) {
    return x.data.join("");
}
exports.joinContiguousSimpleStrings = joinContiguousSimpleStrings;
function parseStringComponent(braceDepth, obj) {
    if (util_1.isNumber(obj) || util_1.isString(obj))
        return obj;
    if (StringRef_1.isStringRef(obj))
        return new StringRef_1.StringRef(0, obj.stringref);
    switch (util_1.mustBeString(obj.type, obj)) {
        case "id":
        case "ws":
        case "number":
            return util_1.mustBeString(obj.string);
        case "bracedstring":
        case "braced":
            if (!util_1.isArray(obj.data)) {
                throw new Error("Expect array for data: " + JSON.stringify(obj));
            }
            return new BracedString_1.BracedString(braceDepth, util_1.flattenMyArray(obj.data).map(function (e) { return parseStringComponent(braceDepth + 1, e); }));
        case "quotedstring":
            if (!util_1.isArray(obj.data)) {
                throw new Error("Expect array for data: " + JSON.stringify(obj));
            }
            var flattened = util_1.flattenMyArray(obj.data);
            return new QuotedString_1.QuotedString(braceDepth, flattened.map(function (e) { return parseStringComponent(braceDepth, e); }));
        default:
            throw new Error("Unexpected complex string type: " + obj.type);
    }
}
exports.parseStringComponent = parseStringComponent;
function toStringBibStringDatum(data) {
    if (util_1.isString(data))
        return data;
    if (util_1.isNumber(data))
        return data + "";
    if (BracedString_1.isBracedString(data)
        || QuotedString_1.isQuotedString(data)
        || QuotedString_1.isOuterQuotedString(data)
        || BracedString_1.isOuterBracedString(data))
        return toStringBibStringData(data.data);
    throw new Error(JSON.stringify(data));
}
exports.toStringBibStringDatum = toStringBibStringDatum;
function toStringBibStringData(data) {
    return data.map(toStringBibStringDatum).join("");
}
exports.toStringBibStringData = toStringBibStringData;
function flattenQuotedStrings(data, hideQuotes) {
    var result = [];
    for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
        var datum = data_1[_i];
        var flattenned = flattenQuotedString(datum, hideQuotes);
        if (util_1.isArray(flattenned)) {
            result = result.concat(flattenned);
        }
        else {
            result.push(flattenned);
        }
    }
    return result;
}
exports.flattenQuotedStrings = flattenQuotedStrings;
var doubleQuotes = ["\""];
function flattenQuotedString(data, hideQuotes) {
    if (BracedString_1.isBracedString(data))
        return data;
    if (QuotedString_1.isQuotedString(data)) {
        var flattenedQuotedString = flattenQuotedStrings(data.data, true);
        if (util_1.isArray(flattenedQuotedString)) {
            return hideQuotes
                ? flattenedQuotedString
                : doubleQuotes.concat(flattenedQuotedString).concat(doubleQuotes);
        }
        else if (hideQuotes)
            return flattenedQuotedString;
        else
            return ["\"", flattenedQuotedString, "\""];
    }
    if (QuotedString_1.isOuterQuotedString(data))
        return flattenQuotedStrings(data.data, true);
    if (BracedString_1.isOuterBracedString(data))
        return flattenQuotedStrings(data.data, false);
    if (util_1.isString(data) || util_1.isNumber(data))
        return data;
    if (StringRef_1.isStringRef(data))
        throw new Error("StringRef should be resolved at this point!");
    else
        throw new Error();
}
function globContiguousStrings(data) {
    var result = [];
    for (var _i = 0, data_2 = data; _i < data_2.length; _i++) {
        var element = data_2[_i];
        if (util_1.isString(element) || util_1.isNumber(element)) {
            if (result.length <= 0) {
                var contiguousSimpleString = {
                    type: "ContiguousSimpleString",
                    data: [element]
                };
                result.push(contiguousSimpleString);
            }
            else {
                var lastElement = result[result.length - 1];
                if (isContiguousSimpleString(lastElement)) {
                    lastElement.data.push(element);
                }
                else {
                    var contiguousSimpleString = {
                        type: "ContiguousSimpleString",
                        data: [element]
                    };
                    result.push(contiguousSimpleString);
                }
            }
        }
        else {
            result.push(element);
        }
    }
    return result;
}
exports.globContiguousStrings = globContiguousStrings;
function splitOnAnd(data) {
    return splitOnPattern(data, /\s+and\s+/g);
}
exports.splitOnAnd = splitOnAnd;
function splitOnComma(data, limit) {
    if (limit === void 0) { limit = 2; }
    return splitOnPattern(data, /\s*,\s*/g, limit);
}
exports.splitOnComma = splitOnComma;
function splitOnPattern(data, pattern, stopAfter) {
    var splitted = [];
    var buffer = [];
    for (var _i = 0, data_3 = data; _i < data_3.length; _i++) {
        var datum = data_3[_i];
        if (util_1.isString(datum) && (stopAfter === undefined || stopAfter > 0)) {
            var match = pattern.exec(datum);
            var end = 0;
            if (match) {
                do {
                    var prevEnd = end;
                    end = match.index + match[0].length;
                    buffer.push(datum.substring(prevEnd, match.index));
                    if (stopAfter === undefined || stopAfter > 0) {
                        splitted.push(buffer);
                        buffer = [];
                        if (stopAfter !== undefined && stopAfter > 0)
                            stopAfter--;
                    }
                    if (stopAfter === undefined || stopAfter > 0)
                        match = pattern.exec(datum);
                    else
                        match = undefined;
                } while (match);
                if (end > 0 && end < datum.length)
                    buffer.push(datum.substring(end));
            }
            else {
                buffer.push(datum);
            }
        }
        else
            buffer.push(datum);
    }
    if (buffer.length > 0)
        splitted.push(buffer);
    return splitted;
}
exports.splitOnPattern = splitOnPattern;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(0);
var BibStringComponent = (function () {
    function BibStringComponent(type, braceDepth, data) {
        this.type = type;
        this.braceDepth = braceDepth;
        this.data = data;
    }
    BibStringComponent.isBibStringComponent = function (x) {
        return typeof x.braceDepth === "number" && typeof x.type === "string";
    };
    BibStringComponent.stringifyDatum = function (datum) {
        if (util_1.isString(datum))
            return datum;
        if (util_1.isNumber(datum))
            return datum.toString();
        if (BibStringComponent.isBibStringComponent(datum))
            return datum.stringify();
        else
            throw new Error("Unexpected state");
    };
    BibStringComponent.prototype.stringify = function () {
        return this.data.map(BibStringComponent.stringifyDatum).join("");
    };
    return BibStringComponent;
}());
exports.BibStringComponent = BibStringComponent;
var BibOuterStringComponent = (function (_super) {
    __extends(BibOuterStringComponent, _super);
    function BibOuterStringComponent(type, data) {
        return _super.call(this, type, 0, data) || this;
    }
    return BibOuterStringComponent;
}(BibStringComponent));
exports.BibOuterStringComponent = BibOuterStringComponent;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var StringRef = (function () {
    function StringRef(braceDepth, stringref) {
        this.braceDepth = braceDepth;
        this.stringref = stringref;
    }
    return StringRef;
}());
exports.StringRef = StringRef;
function isStringRef(stringref) {
    return typeof stringref.stringref === "string";
}
exports.isStringRef = isStringRef;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var BracedString_1 = __webpack_require__(2);
var QuotedString_1 = __webpack_require__(1);
var util_1 = __webpack_require__(0);
var bib_string_utils_1 = __webpack_require__(3);
function isKeyVal(data) {
    return typeof data.key === "string"
        && data.value !== undefined;
}
exports.isKeyVal = isKeyVal;
function newKeyVal(data) {
    if (isKeyVal(data)) {
        return {
            key: data.key,
            value: parseFieldValue(data.value),
        };
    }
    else {
        throw new Error("Was not a KeyVal: " + JSON.stringify(data));
    }
}
exports.newKeyVal = newKeyVal;
function parseFieldValue(value) {
    if (util_1.isNumber(value)) {
        return value;
    }
    var data = util_1.mustBeArray(value.data);
    switch (value.type) {
        case "quotedstringwrapper":
            if (data.length === 1 && util_1.isNumber(data[0]))
                return data[0];
            return new QuotedString_1.OuterQuotedString(data.map(function (e) { return bib_string_utils_1.parseStringComponent(0, e); }));
        case "bracedstringwrapper":
            return new BracedString_1.OuterBracedString(data.map(function (e) { return bib_string_utils_1.parseStringComponent(0, e); }));
        default:
            throw new Error("Unexpected value: " + JSON.stringify(value));
    }
}
exports.parseFieldValue = parseFieldValue;
function normalizeFieldValue(field) {
    if (!field)
        return undefined;
    if (util_1.isNumber(field))
        return field;
    else
        return field.stringify();
}
exports.normalizeFieldValue = normalizeFieldValue;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var KeyVal_1 = __webpack_require__(6);
var StringRef_1 = __webpack_require__(5);
var QuotedString_1 = __webpack_require__(1);
var BracedString_1 = __webpack_require__(2);
var util_1 = __webpack_require__(0);
var bib_string_utils_1 = __webpack_require__(3);
var BibStringEntry = (function () {
    function BibStringEntry(key, value) {
        this.type = "string";
        this.key = key;
        this.value = value;
    }
    return BibStringEntry;
}());
exports.BibStringEntry = BibStringEntry;
function newStringEntry(data) {
    var _a = convertToKeyVal(data), key = _a.key, value = _a.value;
    return new BibStringEntry(key, value);
}
exports.newStringEntry = newStringEntry;
function convertToKeyVal(data) {
    if (KeyVal_1.isKeyVal(data)) {
        return KeyVal_1.newKeyVal(data);
    }
    else {
        if (data.type !== "string") {
            throw new Error("Unexpected node: " + JSON.stringify(data));
        }
        return convertToKeyVal(data.data);
    }
}
function resolveStrings(strings) {
    var resolved = {};
    Object.keys(strings).forEach(function (key) {
        if (!resolved[key])
            resolved[key] = resolveStringReference({}, resolved, strings, strings[key]);
    });
    return resolved;
}
exports.resolveStrings = resolveStrings;
function resolveStringReferences(o, seenBeforeStack, alreadyResolved, refs) {
    return o.data.map(function (datum) {
        if (util_1.isString(datum) || util_1.isNumber(datum))
            return datum;
        else if (StringRef_1.isStringRef(datum))
            return resolveStringRef(seenBeforeStack, refs, datum, alreadyResolved);
        else if (bib_string_utils_1.isBibStringComponent(datum))
            return copyWithResolvedStringReferences(datum, seenBeforeStack, alreadyResolved, refs);
        else
            throw new Error();
    });
}
exports.resolveStringReferences = resolveStringReferences;
function resolveStringReference(seenBeforeStack, alreadyResolved, refs, data) {
    if (util_1.isNumber(data)) {
        return data;
    }
    else if (BracedString_1.isOuterBracedString(data) || QuotedString_1.isOuterQuotedString(data)) {
        return copyOuterWithResolvedStringReferences(data, seenBeforeStack, alreadyResolved, refs);
    }
    if (StringRef_1.isStringRef(data)) {
        return resolveStringRef(seenBeforeStack, refs, data, alreadyResolved);
    }
    return data;
}
exports.resolveStringReference = resolveStringReference;
function resolveStringRef(seenBeforeStack, refs, data, alreadyResolved) {
    var refName = data.stringref;
    if (seenBeforeStack[refName])
        throw new Error("Cycle detected: " + refName);
    if (alreadyResolved[refName]) {
        return alreadyResolved[refName];
    }
    if (!refs[refName])
        throw new Error("Unresolved reference: \"" + data.stringref + "\" (" + JSON.stringify(data) + ")");
    alreadyResolved[refName] = resolveStringReference(Object.assign({}, seenBeforeStack, (_a = {}, _a[refName] = true, _a)), alreadyResolved, refs, refs[refName]);
    return alreadyResolved[refName];
    var _a;
}
function copyWithResolvedStringReferences(obj, seenBeforeStack, alreadyResolved, refs) {
    var newData = resolveStringReferences(obj, seenBeforeStack, alreadyResolved, refs);
    var braceDepth = obj.braceDepth;
    if (QuotedString_1.isQuotedString(obj))
        return new QuotedString_1.QuotedString(braceDepth, newData);
    if (BracedString_1.isBracedString(obj))
        return new BracedString_1.BracedString(braceDepth, newData);
    if (QuotedString_1.isOuterQuotedString(obj))
        return new QuotedString_1.OuterQuotedString(newData);
    if (BracedString_1.isOuterBracedString(obj))
        return new BracedString_1.OuterBracedString(newData);
    else
        throw new Error();
}
exports.copyWithResolvedStringReferences = copyWithResolvedStringReferences;
function copyOuterWithResolvedStringReferences(obj, seenBeforeStack, alreadyResolved, refs) {
    var copied = copyWithResolvedStringReferences(obj, seenBeforeStack, alreadyResolved, refs);
    if (!BracedString_1.isOuterBracedString(copied) && !QuotedString_1.isOuterQuotedString(copied))
        throw new Error();
    return copied;
}
exports.copyOuterWithResolvedStringReferences = copyOuterWithResolvedStringReferences;


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(0);
var QuotedString_1 = __webpack_require__(1);
var StringRef_1 = __webpack_require__(5);
var BracedString_1 = __webpack_require__(2);
var bib_string_utils_1 = __webpack_require__(3);
function word2string(obj) {
    if (typeof obj === "string")
        return obj;
    else if (obj.type == "braced")
        return word2string(obj.data);
    else if (obj.unicode)
        return obj.unicode;
    else if (obj.string)
        return obj.string;
    else if (obj.constructor == Array)
        return obj.map(word2string).join("");
    else
        throw new Error("? " + JSON.stringify(obj));
}
var WHITESPACES = /\s+/g;
var AuthorName = (function () {
    function AuthorName(firstNames, vons, lastNames, jrs) {
        this.firstNames$ = firstNames;
        this.vons$ = vons;
        this.lastNames$ = lastNames;
        this.jrs$ = jrs;
        this.initials = firstNames.map(getFirstLetter);
        this.firstNames = firstNames.map(bib_string_utils_1.toStringBibStringData);
        this.vons = vons.map(bib_string_utils_1.toStringBibStringData);
        this.lastNames = lastNames.map(bib_string_utils_1.toStringBibStringData);
        this.jrs = jrs.map(bib_string_utils_1.toStringBibStringData);
        this.id = this.firstNames.join("-") + "-"
            + this.vons.join("-") + "-"
            + this.lastNames.join("-") + "-"
            + this.jrs.join("-");
    }
    return AuthorName;
}());
exports.AuthorName = AuthorName;
function getFirstLetter(bsd) {
    var asString = bib_string_utils_1.toStringBibStringData(bsd);
    return asString ? asString.charAt(0) : "";
}
function isPartOfName(char) {
    return (char === "," || char.match(/\s/));
}
function startsWithLowerCaseBSD(authorToken) {
    if (authorToken.length > 0)
        return startsWithLowerCase(authorToken[0]);
    else
        return false;
}
function startsWithLowerCase(authorToken) {
    if (util_1.isString(authorToken)) {
        if (!authorToken)
            return false;
        var ch = authorToken.charAt(0);
        return ch.toLowerCase() === ch && ch.toUpperCase() !== ch;
    }
    if (QuotedString_1.isQuotedString(authorToken)) {
        if (!authorToken.data || authorToken.data.length <= 0)
            return false;
        return startsWithLowerCase(authorToken.data[0]);
    }
    if (StringRef_1.isStringRef(authorToken)
        || QuotedString_1.isOuterQuotedString(authorToken)
        || BracedString_1.isOuterBracedString(authorToken))
        throw new Error("Should not do this test on this type");
    return false;
}
function firstVonLast(outer) {
    var authorTokens = bib_string_utils_1.splitOnPattern(outer, WHITESPACES);
    var vonStartInclusive = -1;
    var vonEndExclusive = -1;
    var firstNameEndExclusive = -1;
    for (var i = 0; i < authorTokens.length - 1; i++) {
        if (startsWithLowerCaseBSD(authorTokens[i])) {
            if (vonStartInclusive < 0)
                vonStartInclusive = i;
            vonEndExclusive = i + 1;
        }
    }
    if (vonStartInclusive >= 0)
        firstNameEndExclusive = vonStartInclusive;
    else
        firstNameEndExclusive = authorTokens.length - 1;
    var von = vonStartInclusive >= 0 ? getSubStringAsArray(authorTokens, vonStartInclusive, vonEndExclusive) : [];
    var firstName = getSubStringAsArray(authorTokens, 0, firstNameEndExclusive);
    var lastName = getSubStringAsArray(authorTokens, Math.max(vonEndExclusive, firstNameEndExclusive), authorTokens.length);
    return new AuthorName(firstName, von, lastName, []);
}
function vonLastFirst(vonLastStr, firstStr) {
    var vonLast = bib_string_utils_1.splitOnPattern(vonLastStr, WHITESPACES);
    var first = bib_string_utils_1.splitOnPattern(firstStr, WHITESPACES);
    var vonStartInclusive = -1;
    var vonEndExclusive = -1;
    for (var i = 0; i < vonLast.length - 1; i++)
        if (startsWithLowerCaseBSD(vonLast[i])) {
            if (vonStartInclusive < 0)
                vonStartInclusive = i;
            vonEndExclusive = i + 1;
        }
    var von = vonStartInclusive >= 0 ? getSubStringAsArray(vonLast, 0, vonEndExclusive) : [];
    var firstName = first;
    var lastName = getSubStringAsArray(vonLast, Math.max(vonEndExclusive, 0));
    return new AuthorName(firstName, von, lastName, []);
}
function getSubStringAsArray(tokens, startIncl, endExcl) {
    var arr = [];
    for (var i = startIncl; i < (endExcl === undefined ? tokens.length : endExcl); i++) {
        arr.push(tokens[i]);
    }
    return arr;
}
function vonLastJrFirst(vonLastStr, jrStr, firstStr) {
    var vonLast = bib_string_utils_1.splitOnPattern(vonLastStr, WHITESPACES);
    var first = bib_string_utils_1.splitOnPattern(firstStr, WHITESPACES);
    var jr = bib_string_utils_1.splitOnPattern(jrStr, WHITESPACES);
    var vonStartInclusive = -1;
    var vonEndExclusive = -1;
    for (var i = 0; i < vonLast.length - 1; i++)
        if (startsWithLowerCaseBSD(vonLast[i])) {
            if (vonStartInclusive < 0)
                vonStartInclusive = i;
            vonEndExclusive = i + 1;
        }
    var von = vonStartInclusive >= 0 ? getSubStringAsArray(vonLast, 0, vonEndExclusive) : [];
    var lastName = getSubStringAsArray(vonLast, Math.max(vonEndExclusive, 0));
    return new AuthorName(first, von, lastName, jr);
}
function parseAuthorName(normalizedFieldValue) {
    var partitions = bib_string_utils_1.splitOnComma(normalizedFieldValue);
    switch (partitions.length) {
        case 1:
            return firstVonLast(partitions[0]);
        case 2:
            return vonLastFirst(mdbsd(partitions[0]), mdbsd(partitions[1]));
        case 3:
            return vonLastJrFirst(mdbsd(partitions[0]), mdbsd(partitions[1]), mdbsd(partitions[2]));
        default:
            throw new Error("Could not parse author name: partitioned as " + JSON.stringify(partitions) + " in " + JSON.stringify(normalizedFieldValue));
    }
}
exports.parseAuthorName = parseAuthorName;
function isdbsd(x) {
    return x !== undefined;
}
function mdbsd(x) {
    if (isdbsd(x))
        return x;
    else
        throw new Error("???????");
}
var Authorrr = (function () {
    function Authorrr(first, von, last) {
        this.first = first;
        this.von = von;
        this.last = last;
    }
    return Authorrr;
}());
exports.Authorrr = Authorrr;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(0);
var Author_1 = __webpack_require__(8);
var QuotedString_1 = __webpack_require__(1);
var BibStringComponent_1 = __webpack_require__(4);
var bib_string_utils_1 = __webpack_require__(3);
var Authors = (function (_super) {
    __extends(Authors, _super);
    function Authors(fieldValue) {
        var _this = this;
        var data = util_1.isNumber(fieldValue) ? [fieldValue] : fieldValue.data;
        _this = _super.call(this, "authors", data) || this;
        var authorNames = determineAuthorNames$(fieldValue);
        _this.authors$ = authorNames.map(function (name) { return parseAuthor(name); });
        return _this;
    }
    return Authors;
}(BibStringComponent_1.BibOuterStringComponent));
exports.Authors = Authors;
function parseAuthor(data) {
    return Author_1.parseAuthorName(data);
}
function determineAuthorNames$(data) {
    if (util_1.isNumber(data)) {
        return determineAuthorNames([data]);
    }
    else {
        return determineAuthorNames(data.data, QuotedString_1.isOuterQuotedString(data));
    }
}
exports.determineAuthorNames$ = determineAuthorNames$;
function determineAuthorNames(data, hideQuotes) {
    var globbed = bib_string_utils_1.globContiguousStrings(bib_string_utils_1.flattenQuotedStrings(data, hideQuotes));
    var normalizedString = globbed.map(function (e) { return bib_string_utils_1.isContiguousSimpleString(e) ? bib_string_utils_1.joinContiguousSimpleStrings(e) : e; });
    return bib_string_utils_1.splitOnAnd(normalizedString);
}
function mustBeAuthors(x) {
    if (!isAuthors(x))
        throw new Error();
    return x;
}
exports.mustBeAuthors = mustBeAuthors;
function isAuthors(x) {
    return (util_1.isArray(x["authors$"]) && x.type === "authors");
}
exports.isAuthors = isAuthors;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(0);
var BibComment = (function () {
    function BibComment(data) {
        this.type = "comment";
        this.data = data;
        this.string = data.join("");
    }
    BibComment.prototype.toString = function () {
        return this.string;
    };
    return BibComment;
}());
exports.BibComment = BibComment;
var CommentEntry = (function () {
    function CommentEntry(type, data) {
        this.type = type;
        this.data = data;
        this.string = data.join("");
    }
    CommentEntry.prototype.toString = function () {
        return this.string;
    };
    return CommentEntry;
}());
exports.CommentEntry = CommentEntry;
function isBibComment(n) {
    return n.type === "comment" && util_1.isArray(n.data);
}
exports.isBibComment = isBibComment;
var flattenO = function (wrapper) { return util_1.isString(wrapper) ? wrapper
    : typeof wrapper === "number" ? wrapper.toString()
        : wrapper["type"] === "@bib" ? "@" + util_1.mustBeString(wrapper.string)
            : wrapper["type"] === "escapedEntry" ? "\\" + flattenO(wrapper.data)
                : util_1.mustBeString(wrapper.string); };
function flattenPlainText(data) {
    return util_1.flattenMyArray(data).map(flattenO);
}
exports.flattenPlainText = flattenPlainText;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Authors_1 = __webpack_require__(9);
var BibStringEntry_1 = __webpack_require__(7);
var KeyVal_1 = __webpack_require__(6);
var BibEntry = (function () {
    function BibEntry(type, id, fields) {
        this.type = type;
        this._id = id;
        this.fields = fields;
        this.sortkey$ = "";
        this.title$ = "";
    }
    BibEntry.prototype.getField = function (key) {
        return this.fields[key.toLowerCase()];
    };
    BibEntry.prototype.getFieldAsString = function (key) {
        var field = this.getField(key);
        return KeyVal_1.normalizeFieldValue(field);
    };
    BibEntry.prototype.getAuthors = function () {
        var field = this.fields["author"];
        if (field === undefined)
            return field;
        return Authors_1.mustBeAuthors(field);
    };
    return BibEntry;
}());
exports.BibEntry = BibEntry;
function parseEntryFields(fields) {
    var fieldz = {};
    Object.keys(fields).forEach(function (key) {
        switch (key) {
            default:
                fieldz[key] = KeyVal_1.parseFieldValue(fields[key]);
                break;
        }
    });
    return fieldz;
}
exports.parseEntryFields = parseEntryFields;
function isBibEntry(x) {
    return typeof x["type"] === "string"
        && typeof x["_id"] === "string"
        && !!x["fields"];
}
exports.isBibEntry = isBibEntry;
function processEntry(entry, strings$) {
    var processedFields = {};
    var fields$ = entry.fields;
    Object.keys(entry.fields).forEach(function (key) {
        var field$ = BibStringEntry_1.resolveStringReference({}, processedFields, strings$, fields$[key]);
        switch (key) {
            case "author":
                processedFields[key] = new Authors_1.Authors(field$);
                break;
            case "title":
                processedFields[key] = (field$);
                break;
            case "incollection":
            default:
                processedFields[key] = field$;
                break;
        }
    });
    return new BibEntry(entry.type, entry._id, processedFields);
}
exports.processEntry = processEntry;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(0);
var BibFile_1 = __webpack_require__(13);
var Preamble = (function () {
    function Preamble(data) {
        this.type = ("preamble");
        this.data = data;
        this.string = data.join("");
    }
    Preamble.prototype.toString = function () {
        return this.string;
    };
    return Preamble;
}());
exports.Preamble = Preamble;
function isPreamble(x) {
    return x.type === "preamble" && !!x.data;
}
exports.isPreamble = isPreamble;
function newPreambleNode(data) {
    var flattened = BibFile_1.parseBibEntriesAndNonEntries(util_1.mustBeArray(data.data));
    return new Preamble(flattened);
}
exports.newPreambleNode = newPreambleNode;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var nearley = __webpack_require__(19);
var ts_parser_1 = __webpack_require__(20);
var util_1 = __webpack_require__(0);
var KeyVal_1 = __webpack_require__(6);
var BibEntry_1 = __webpack_require__(11);
var BibComment_1 = __webpack_require__(10);
var BibPreamble_1 = __webpack_require__(12);
var BibStringEntry_1 = __webpack_require__(7);
var Lexer_1 = __webpack_require__(21);
var BibFilePresenter = (function () {
    function BibFilePresenter(content) {
        var _this = this;
        this.content = content;
        this.comments = content.filter(BibComment_1.isBibComment).map(function (c) {
            if (BibComment_1.isBibComment(c))
                return c;
            else
                throw new Error();
        });
        this.preambles_raw = content.filter(function (c) { return BibPreamble_1.isPreamble(c); }).map(function (c) {
            if (BibPreamble_1.isPreamble(c))
                return c;
            else
                throw new Error();
        });
        this.preamble$ = this.preambles_raw.map(function (p) { return p.toString(); }).join("\n");
        var strings = {};
        this.content.forEach(function (entry) {
            if (KeyVal_1.isKeyVal(entry)) {
                if (!!strings[entry.key])
                    throw new Error("String with id " + entry.key + " was defined more than once");
                strings[entry.key] = entry.value;
            }
        });
        this.strings_raw = strings;
        this.strings$ = BibStringEntry_1.resolveStrings(strings);
        this.entries_raw = content.filter(function (c) { return BibEntry_1.isBibEntry(c); }).map(function (c) {
            if (BibEntry_1.isBibEntry(c))
                return c;
            else
                throw new Error();
        });
        var entryMap = {};
        this.entries_raw.forEach(function (entry) {
            var key = entry._id.toLowerCase();
            if (!!entryMap[key])
                throw new Error("Entry with id " + key + " was defined more than once");
            entryMap[key] = BibEntry_1.processEntry(entry, _this.strings$);
        });
        this.entries$ = entryMap;
    }
    BibFilePresenter.prototype.getEntry = function (id) {
        return this.entries$[id.toLowerCase()];
    };
    return BibFilePresenter;
}());
exports.BibFilePresenter = BibFilePresenter;
function parseNonEntry(nonEntry) {
    if (!util_1.isArray(nonEntry.data) || nonEntry.type !== "NON_ENTRY")
        throw new Error();
    return new BibComment_1.BibComment(BibComment_1.flattenPlainText(nonEntry.data));
}
function parseEntry(entry) {
    switch (typeof entry) {
        case "object":
            var data = entry.data;
            if (typeof data["@type"] === "string") {
                return new BibEntry_1.BibEntry(data["@type"], data._id, BibEntry_1.parseEntryFields(data.fields));
            }
            var type = util_1.mustBeString(data.type);
            switch (type) {
                case "string":
                    return BibStringEntry_1.newStringEntry(data);
                case "preamble":
                    return BibPreamble_1.newPreambleNode(data);
                default:
                    throw new Error("Unexpected entry parsed: " + data.type);
            }
        default:
            throw new Error("Expected object as data for entry");
    }
}
exports.parseBibEntriesAndNonEntries = function (parse) {
    return parse.map(function (entity) {
        switch (entity.type) {
            case "NON_ENTRY":
                return (parseNonEntry(entity));
            case "ENTRY":
                return (parseEntry(entity));
            default:
                throw new Error("Expected ENTRY or NON_ENTRY");
        }
    });
};
function parseBibFile(input) {
    var p = new nearley.Parser(ts_parser_1.grammar.ParserRules, ts_parser_1.grammar.ParserStart);
    p.feed(new Lexer_1.default(input).readTokens());
    var res = p.results;
    var parse = res[0];
    return new BibFilePresenter(exports.parseBibEntriesAndNonEntries(parse));
}
exports.parseBibFile = parseBibFile;


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function newToken(type, string) {
    return {
        type: type,
        string: string
    };
}
exports.newToken = newToken;
exports.specialChars = {
    "@": true,
    "(": true,
    ")": true,
    "{": true,
    "}": true,
    "#": true,
    "=": true,
    ",": true,
    "\\": true,
    "\"": true,
};
function isSpecialChar(c) {
    return exports.specialChars.hasOwnProperty(c);
}
exports.isSpecialChar = isSpecialChar;
exports.escapableChars = {
    "\\": true,
    "@": true,
    "{": true,
    "}": true
};
function isEscapableChar(c) {
    return exports.escapableChars.hasOwnProperty(c);
}
exports.isEscapableChar = isEscapableChar;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.WS = "ws";
function newWhitespace(string) {
    return {
        type: "ws",
        string: string
    };
}
exports.newWhitespace = newWhitespace;
function isWhitespace(token) {
    return typeof token.string === "string" && token.type === exports.WS;
}
exports.isWhitespace = isWhitespace;
exports.singleWhitespaces = {
    " ": true,
    "\t": true,
    "\r": true,
    "\n": true
};
function isSingleWhiteSpaceCharacter(c) {
    return exports.singleWhitespaces.hasOwnProperty(c);
}
exports.isSingleWhiteSpaceCharacter = isSingleWhiteSpaceCharacter;


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function newNumber(string) {
    return {
        type: "number",
        string: string
    };
}
exports.newNumber = newNumber;
exports.numericChars = {
    "0": true,
    "1": true,
    "2": true,
    "3": true,
    "4": true,
    "5": true,
    "6": true,
    "7": true,
    "8": true,
    "9": true
};
function isNum(c) {
    return exports.numericChars.hasOwnProperty(c);
}
exports.isNum = isNum;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(8));
__export(__webpack_require__(9));
__export(__webpack_require__(18));
__export(__webpack_require__(10));
__export(__webpack_require__(11));
__export(__webpack_require__(12));
__export(__webpack_require__(7));
__export(__webpack_require__(3));
__export(__webpack_require__(4));
__export(__webpack_require__(2));
__export(__webpack_require__(1));
__export(__webpack_require__(5));
__export(__webpack_require__(6));
__export(__webpack_require__(13));
__export(__webpack_require__(0));


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(0);
exports.address = "address";
exports.author = "author";
exports.booktitle = "booktitle";
exports.chapter = "chapter";
exports.edition = "edition";
exports.editor = "editor";
exports.howpublished = "howpublished";
exports.institution = "institution";
exports.journal = "journal";
exports.month = "month";
exports.note = "note";
exports.number = "number";
exports.organization = "organization";
exports.pages = "pages";
exports.publisher = "publisher";
exports.school = "school";
exports.series = "series";
exports.title = "title";
exports.type = "type";
exports.volume = "volume";
exports.year = "year";
exports.optionalFields = {
    "book": [["volume", "number"], "series", "address", "edition", "month", "note"],
    "booklet": ["author", "howpublished", "address", "address", "month", "year", "note"],
    "conference": ["editor", ["volume", "number"], "series", "pages", "address", "month", "organization", "publisher", "note"],
    "inproceedings": ["editor", ["volume", "number"], exports.series, "pages", "address", "month", "organization", "publisher", "note"],
    "inbook": ["volume", "number", "series", "type", "address", "edition", "month", "note"],
    "incollection": ["editor", ["volume", "number"], "series", "type", "chapter", "pages", "address", "edition", "month", "note"],
    "manual": ["author", "organization", "year", "address", "edition", "month", "note"],
    "mastersthesis": ["type", "address", "month", "note"],
    "misc": [],
    "phdthesis": ["type", "address", "month", "note"],
    "proceedings": ["editor", ["volume", "number"], "series", "address", "month", "organization", "publisher", "note"],
    "techreport": ["type", "address", "number", "month", "note"],
    "unpublished": ["month", "year"]
};
exports.mandatoryFields = {
    "article": ["author", "title", "year", "journal"],
    "book": [["author", "editor"], "title", "publisher", "year"],
    "booklet": ["title"],
    "conference": ["author", "title", "booktitle", "year"],
    "inproceedings": ["author", "title", "booktitle", "year"],
    "inbook": [["author", "editor"], "title", ["chapter", "pages"]],
    "incollection": ["author", "title", "booktitle", "publisher", "year"],
    "manual": ["title"],
    "mastersthesis": ["author", "title", "school", "year"],
    "misc": [["author", "title", "howpublished", "year", "month", "note"]],
    "phdthesis": ["author", "title", "school", "year"],
    "proceedings": ["year", "title"],
    "techreport": ["author", "title", "institution", "year"],
    "unpublished": ["author", "title", "note"]
};
function hasOptionalFields(s) {
    return exports.optionalFields.hasOwnProperty(s);
}
exports.hasOptionalFields = hasOptionalFields;
function hasMandatoryFields(s) {
    return exports.mandatoryFields.hasOwnProperty(s);
}
exports.hasMandatoryFields = hasMandatoryFields;
function getMandatoryFields(s) {
    if (hasMandatoryFields(s)) {
        return exports.mandatoryFields[s];
    }
    else {
        return [];
    }
}
exports.getMandatoryFields = getMandatoryFields;
function getOptionalFields(s) {
    if (hasOptionalFields(s)) {
        return exports.optionalFields[s];
    }
    else {
        return [];
    }
}
exports.getOptionalFields = getOptionalFields;
exports.findError = function (entry, field) {
    var fields = entry.fields;
    if (util_1.isString(field)) {
        if (!fields[field])
            return new Error("Warning: expected " + entry.type + " with id " + entry._id
                + " to have the field: " + field);
    }
    else if (util_1.isArray(field)) {
        var hasAllFields = field.reduce(function (acc, fieldName) {
            if (util_1.isString(fieldName)) {
                return (acc && fields.hasOwnProperty(fieldName));
            }
            else
                throw new Error();
        }, true);
        if (!hasAllFields) {
            return new Error("Expected " + entry.type + " with id " + entry._id
                + " to have one of the following fields: " + field);
        }
    }
};


/***/ }),
/* 19 */
/***/ (function(module, exports) {

(function(root, factory) {
    if (typeof module === 'object' && module.exports) {
        module.exports = factory();
    } else {
        root.nearley = factory();
    }
}(this, function() {

function Rule(name, symbols, postprocess) {
    this.id = ++Rule.highestId;
    this.name = name;
    this.symbols = symbols;        // a list of literal | regex class | nonterminal
    this.postprocess = postprocess;
    return this;
}
Rule.highestId = 0;

Rule.prototype.toString = function(withCursorAt) {
    function stringifySymbolSequence (e) {
        return e.literal ? JSON.stringify(e.literal) :
               e.type ? '%' + e.type : e.toString();
    }
    var symbolSequence = (typeof withCursorAt === "undefined")
                         ? this.symbols.map(stringifySymbolSequence).join(' ')
                         : (   this.symbols.slice(0, withCursorAt).map(stringifySymbolSequence).join(' ')
                             + " ● "
                             + this.symbols.slice(withCursorAt).map(stringifySymbolSequence).join(' ')     );
    return this.name + " → " + symbolSequence;
}


// a State is a rule at a position from a given starting point in the input stream (reference)
function State(rule, dot, reference, wantedBy) {
    this.rule = rule;
    this.dot = dot;
    this.reference = reference;
    this.data = [];
    this.wantedBy = wantedBy;
    this.isComplete = this.dot === rule.symbols.length;
}

State.prototype.toString = function() {
    return "{" + this.rule.toString(this.dot) + "}, from: " + (this.reference || 0);
};

State.prototype.nextState = function(child) {
    var state = new State(this.rule, this.dot + 1, this.reference, this.wantedBy);
    state.left = this;
    state.right = child;
    if (state.isComplete) {
        state.data = state.build();
    }
    return state;
};

State.prototype.build = function() {
    var children = [];
    var node = this;
    do {
        children.push(node.right.data);
        node = node.left;
    } while (node.left);
    children.reverse();
    return children;
};

State.prototype.finish = function() {
    if (this.rule.postprocess) {
        this.data = this.rule.postprocess(this.data, this.reference, Parser.fail);
    }
};


function Column(grammar, index) {
    this.grammar = grammar;
    this.index = index;
    this.states = [];
    this.wants = {}; // states indexed by the non-terminal they expect
    this.scannable = []; // list of states that expect a token
    this.completed = {}; // states that are nullable
}


Column.prototype.process = function(nextColumn) {
    var states = this.states;
    var wants = this.wants;
    var completed = this.completed;

    for (var w = 0; w < states.length; w++) { // nb. we push() during iteration
        var state = states[w];

        if (state.isComplete) {
            state.finish();
            if (state.data !== Parser.fail) {
                // complete
                var wantedBy = state.wantedBy;
                for (var i = wantedBy.length; i--; ) { // this line is hot
                    var left = wantedBy[i];
                    this.complete(left, state);
                }

                // special-case nullables
                if (state.reference === this.index) {
                    // make sure future predictors of this rule get completed.
                    var exp = state.rule.name;
                    (this.completed[exp] = this.completed[exp] || []).push(state);
                }
            }

        } else {
            // queue scannable states
            var exp = state.rule.symbols[state.dot];
            if (typeof exp !== 'string') {
                this.scannable.push(state);
                continue;
            }

            // predict
            if (wants[exp]) {
                wants[exp].push(state);

                if (completed.hasOwnProperty(exp)) {
                    var nulls = completed[exp];
                    for (var i = 0; i < nulls.length; i++) {
                        var right = nulls[i];
                        this.complete(state, right);
                    }
                }
            } else {
                wants[exp] = [state];
                this.predict(exp);
            }
        }
    }
}

Column.prototype.predict = function(exp) {
    var rules = this.grammar.byName[exp] || [];

    for (var i = 0; i < rules.length; i++) {
        var r = rules[i];
        var wantedBy = this.wants[exp];
        var s = new State(r, 0, this.index, wantedBy);
        this.states.push(s);
    }
}

Column.prototype.complete = function(left, right) {
    var inp = right.rule.name;
    if (left.rule.symbols[left.dot] === inp) {
        var copy = left.nextState(right);
        this.states.push(copy);
    }
}


function Grammar(rules, start) {
    this.rules = rules;
    this.start = start || this.rules[0].name;
    var byName = this.byName = {};
    this.rules.forEach(function(rule) {
        if (!byName.hasOwnProperty(rule.name)) {
            byName[rule.name] = [];
        }
        byName[rule.name].push(rule);
    });
}

// So we can allow passing (rules, start) directly to Parser for backwards compatibility
Grammar.fromCompiled = function(rules, start) {
    var lexer = rules.Lexer;
    if (rules.ParserStart) {
      start = rules.ParserStart;
      rules = rules.ParserRules;
    }
    var rules = rules.map(function (r) { return (new Rule(r.name, r.symbols, r.postprocess)); });
    var g = new Grammar(rules, start);
    g.lexer = lexer; // nb. storing lexer on Grammar is iffy, but unavoidable
    return g;
}


function StreamLexer() {
  this.reset("");
}

StreamLexer.prototype.reset = function(data, state) {
    this.buffer = data;
    this.index = 0;
    this.line = state ? state.line : 1;
    this.lastLineBreak = state ? -state.col : 0;
}

StreamLexer.prototype.next = function() {
    if (this.index < this.buffer.length) {
        var ch = this.buffer[this.index++];
        if (ch === '\n') {
          this.line += 1;
          this.lastLineBreak = this.index;
        }
        return {value: ch};
    }
}

StreamLexer.prototype.save = function() {
  return {
    line: this.line,
    col: this.index - this.lastLineBreak,
  }
}

StreamLexer.prototype.formatError = function(token, message) {
    // nb. this gets called after consuming the offending token,
    // so the culprit is index-1
    var buffer = this.buffer;
    if (typeof buffer === 'string') {
        var nextLineBreak = buffer.indexOf('\n', this.index);
        if (nextLineBreak === -1) nextLineBreak = buffer.length;
        var line = buffer.substring(this.lastLineBreak, nextLineBreak)
        var col = this.index - this.lastLineBreak;
        message += " at line " + this.line + " col " + col + ":\n\n";
        message += "  " + line + "\n"
        message += "  " + Array(col).join(" ") + "^"
        return message;
    } else {
        return message + " at index " + (this.index - 1);
    }
}


function Parser(rules, start, options) {
    if (rules instanceof Grammar) {
        var grammar = rules;
        var options = start;
    } else {
        var grammar = Grammar.fromCompiled(rules, start);
    }
    this.grammar = grammar;

    // Read options
    this.options = {
        keepHistory: false,
        lexer: grammar.lexer || new StreamLexer,
    };
    for (var key in (options || {})) {
        this.options[key] = options[key];
    }

    // Setup lexer
    this.lexer = this.options.lexer;
    this.lexerState = undefined;

    // Setup a table
    var column = new Column(grammar, 0);
    var table = this.table = [column];

    // I could be expecting anything.
    column.wants[grammar.start] = [];
    column.predict(grammar.start);
    // TODO what if start rule is nullable?
    column.process();
    this.current = 0; // token index
}

// create a reserved token for indicating a parse fail
Parser.fail = {};

Parser.prototype.feed = function(chunk) {
    var lexer = this.lexer;
    lexer.reset(chunk, this.lexerState);

    var token;
    while (token = lexer.next()) {
        // We add new states to table[current+1]
        var column = this.table[this.current];

        // GC unused states
        if (!this.options.keepHistory) {
            delete this.table[this.current - 1];
        }

        var n = this.current + 1;
        var nextColumn = new Column(this.grammar, n);
        this.table.push(nextColumn);

        // Advance all tokens that expect the symbol
        var literal = token.value;
        var value = lexer.constructor === StreamLexer ? token.value : token;
        var scannable = column.scannable;
        for (var w = scannable.length; w--; ) {
            var state = scannable[w];
            var expect = state.rule.symbols[state.dot];
            // Try to consume the token
            // either regex or literal
            if (expect.test ? expect.test(value) :
                expect.type ? expect.type === token.type
                            : expect.literal === literal) {
                // Add it
                var next = state.nextState({data: value, token: token, isToken: true, reference: n - 1});
                nextColumn.states.push(next);
            }
        }

        // Next, for each of the rules, we either
        // (a) complete it, and try to see if the reference row expected that
        //     rule
        // (b) predict the next nonterminal it expects by adding that
        //     nonterminal's start state
        // To prevent duplication, we also keep track of rules we have already
        // added

        nextColumn.process();

        // If needed, throw an error:
        if (nextColumn.states.length === 0) {
            // No states at all! This is not good.
            var message = this.lexer.formatError(token, "invalid syntax") + "\n";
            message += "Unexpected " + (token.type ? token.type + " token: " : "");
            message += JSON.stringify(token.value !== undefined ? token.value : token) + "\n";
            var err = new Error(message);
            err.offset = this.current;
            err.token = token;
            throw err;
        }

        // maybe save lexer state
        if (this.options.keepHistory) {
          column.lexerState = lexer.save()
        }

        this.current++;
    }
    if (column) {
      this.lexerState = lexer.save()
    }

    // Incrementally keep track of results
    this.results = this.finish();

    // Allow chaining, for whatever it's worth
    return this;
};

Parser.prototype.save = function() {
    var column = this.table[this.current];
    column.lexerState = this.lexerState;
    return column;
};

Parser.prototype.restore = function(column) {
    var index = column.index;
    this.current = index;
    this.table[index] = column;
    this.table.splice(index + 1);
    this.lexerState = column.lexerState;

    // Incrementally keep track of results
    this.results = this.finish();
};

// nb. deprecated: use save/restore instead!
Parser.prototype.rewind = function(index) {
    if (!this.options.keepHistory) {
        throw new Error('set option `keepHistory` to enable rewinding')
    }
    // nb. recall column (table) indicies fall between token indicies.
    //        col 0   --   token 0   --   col 1
    this.restore(this.table[index]);
};

Parser.prototype.finish = function() {
    // Return the possible parsings
    var considerations = [];
    var start = this.grammar.start;
    var column = this.table[this.table.length - 1]
    column.states.forEach(function (t) {
        if (t.rule.name === start
                && t.dot === t.rule.symbols.length
                && t.reference === 0
                && t.data !== Parser.fail) {
            considerations.push(t);
        }
    });
    return considerations.map(function(c) {return c.data; });
};

return {
    Parser: Parser,
    Grammar: Grammar,
    Rule: Rule,
};

}));


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function id(x) {
    return x[0];
}
var isNumber = function (x) {
    return x.constructor === Number || (typeof x === "object" && x.type === "number");
};
var tok_id = {
    test: function (x) {
        return typeof x === "object" && x.type === "id";
    }
};
var entry_type_bib = {
    test: function (x) {
        return typeof x === "object" && x.type === "@bib";
    }
};
var entry_type_string = {
    test: function (x) {
        return typeof x === "object" && x.type === "@string";
    }
};
var entry_type_preamble = {
    test: function (x) {
        return typeof x === "object" && x.type === "@preamble";
    }
};
var entry_type_comment = {
    test: function (x) {
        return typeof x === "object" && x.type === "@comment";
    }
};
var ws = {
    test: function (x) {
        return typeof x === "object" && x.type === "ws";
    }
};
var num = { test: isNumber };
var pound = { literal: "#" };
var eq = { literal: "=" };
var esc = { literal: "\\" };
var paren_l = { literal: "(" };
var paren_r = { literal: ")" };
var brace_l = { literal: "{" };
var brace_r = { literal: "}" };
var quote_dbl = { literal: "\"" };
var comma = { literal: "," };
function addToObj(obj, keyval) {
    if (keyval.type !== "keyval")
        throw new Error("Expected a keyval object");
    var key = keyval.key.toLowerCase();
    if (obj.fields[key]) {
        return;
    }
    else {
        obj.fields[key] = keyval.value;
        return obj;
    }
}
function joinTokens(arr) {
    var strs = [];
    for (var i = 0; i < arr.length; i++) {
        if (typeof arr[i] === "object") {
            if (!arr[i].string)
                throw new Error("Expected token to have a string field called 'string' in object " + JSON.stringify(arr[i]));
            strs.push(arr[i].string);
        }
        else if (typeof arr[i] === "string" || typeof arr[i] === "number") {
            strs.push(arr[i]);
        }
        else
            throw new Error("Could not handle token " + JSON.stringify(arr[i]) + " in array " + JSON.stringify(arr));
    }
    return strs.join("");
}
exports.grammar = {
    Lexer: undefined,
    ParserRules: [
        { "name": "main$ebnf$1", "symbols": ["non_entry"], "postprocess": id },
        {
            "name": "main$ebnf$1", "symbols": [], "postprocess": function () {
                return undefined;
            }
        },
        { "name": "main$ebnf$2", "symbols": [] },
        { "name": "main$ebnf$2$subexpression$1$ebnf$1", "symbols": ["non_entry"], "postprocess": id },
        {
            "name": "main$ebnf$2$subexpression$1$ebnf$1", "symbols": [], "postprocess": function () {
                return undefined;
            }
        },
        { "name": "main$ebnf$2$subexpression$1", "symbols": ["entry", "main$ebnf$2$subexpression$1$ebnf$1"] },
        {
            "name": "main$ebnf$2",
            "symbols": ["main$ebnf$2", "main$ebnf$2$subexpression$1"],
            "postprocess": function arrpush(d) {
                return d[0].concat([d[1]]);
            }
        },
        {
            "name": "main",
            "symbols": ["main$ebnf$1", "main$ebnf$2"],
            "postprocess": function (data) {
                var topLevelObjects = [];
                if (data[0])
                    topLevelObjects.push({ type: "NON_ENTRY", data: data[0] });
                for (var i = 0; i < data[1].length; i++) {
                    topLevelObjects.push({ type: "ENTRY", data: data[1][i][0] });
                    if (data[1][i][1])
                        topLevelObjects.push({ type: "NON_ENTRY", data: data[1][i][1] });
                }
                return topLevelObjects;
            }
        },
        { "name": "_$ebnf$1", "symbols": [] },
        {
            "name": "_$ebnf$1", "symbols": ["_$ebnf$1", ws], "postprocess": function arrpush(d) {
                return d[0].concat([d[1]]);
            }
        },
        { "name": "_", "symbols": ["_$ebnf$1"] },
        { "name": "entry_decl$subexpression$1", "symbols": [entry_type_bib] },
        { "name": "entry_decl$subexpression$1", "symbols": [entry_type_string] },
        { "name": "entry_decl$subexpression$1", "symbols": [entry_type_preamble] },
        { "name": "entry_decl$subexpression$1", "symbols": [entry_type_comment] },
        {
            "name": "entry_decl",
            "symbols": ["entry_decl$subexpression$1"],
            "postprocess": function (data) {
                return data[0][0];
            }
        },
        { "name": "entry$subexpression$1", "symbols": ["bib_entry"] },
        { "name": "entry$subexpression$1", "symbols": ["string_entry"] },
        { "name": "entry$subexpression$1", "symbols": ["preamble_entry"] },
        { "name": "entry$subexpression$1", "symbols": ["comment_entry"] },
        {
            "name": "entry", "symbols": ["entry$subexpression$1"], "postprocess": function (data) {
                return data[0][0];
            }
        },
        {
            "name": "comment", "symbols": ["main"], "postprocess": function (data) {
                return data[0];
            }
        },
        { "name": "comment_liberal$ebnf$1", "symbols": [] },
        { "name": "comment_liberal$ebnf$1$subexpression$1", "symbols": [/./] },
        {
            "name": "comment_liberal$ebnf$1",
            "symbols": ["comment_liberal$ebnf$1", "comment_liberal$ebnf$1$subexpression$1"],
            "postprocess": function arrpush(d) {
                return d[0].concat([d[1]]);
            }
        },
        {
            "name": "comment_liberal",
            "symbols": ["comment_liberal$ebnf$1"],
            "postprocess": function (data) {
                var toeknz = [];
                for (var tk = 0; tk < data[0].length; tk++)
                    toeknz.push(data[0][tk][0]);
                return toeknz;
            }
        },
        { "name": "entry_body_comment$subexpression$1$macrocall$2", "symbols": ["comment"] },
        {
            "name": "entry_body_comment$subexpression$1$macrocall$1",
            "symbols": [paren_l, "entry_body_comment$subexpression$1$macrocall$2", paren_r],
            "postprocess": function (data) {
                return data[1];
            }
        },
        { "name": "entry_body_comment$subexpression$1", "symbols": ["entry_body_comment$subexpression$1$macrocall$1"] },
        { "name": "entry_body_comment$subexpression$1$macrocall$4", "symbols": ["comment"] },
        {
            "name": "entry_body_comment$subexpression$1$macrocall$3",
            "symbols": [brace_l, "entry_body_comment$subexpression$1$macrocall$4", brace_r],
            "postprocess": function (data) {
                return data[1];
            }
        },
        { "name": "entry_body_comment$subexpression$1", "symbols": ["entry_body_comment$subexpression$1$macrocall$3"] },
        {
            "name": "entry_body_comment",
            "symbols": ["entry_body_comment$subexpression$1"],
            "postprocess": function (data) {
                return data[0][0][0];
            }
        },
        { "name": "entry_body_string$subexpression$1$macrocall$2", "symbols": ["keyval"] },
        {
            "name": "entry_body_string$subexpression$1$macrocall$1",
            "symbols": [paren_l, "_", "entry_body_string$subexpression$1$macrocall$2", "_", paren_r],
            "postprocess": function (data) {
                return data[2];
            }
        },
        { "name": "entry_body_string$subexpression$1", "symbols": ["entry_body_string$subexpression$1$macrocall$1"] },
        { "name": "entry_body_string$subexpression$1$macrocall$4", "symbols": ["keyval"] },
        {
            "name": "entry_body_string$subexpression$1$macrocall$3",
            "symbols": [brace_l, "_", "entry_body_string$subexpression$1$macrocall$4", "_", brace_r],
            "postprocess": function (data) {
                return data[2];
            }
        },
        { "name": "entry_body_string$subexpression$1", "symbols": ["entry_body_string$subexpression$1$macrocall$3"] },
        {
            "name": "entry_body_string",
            "symbols": ["entry_body_string$subexpression$1"],
            "postprocess": function (data) {
                return data[0][0][0];
            }
        },
        { "name": "entry_body_bib$subexpression$1$macrocall$2", "symbols": ["bib_content"] },
        {
            "name": "entry_body_bib$subexpression$1$macrocall$1",
            "symbols": [paren_l, "_", "entry_body_bib$subexpression$1$macrocall$2", "_", paren_r],
            "postprocess": function (data) {
                return data[2];
            }
        },
        { "name": "entry_body_bib$subexpression$1", "symbols": ["entry_body_bib$subexpression$1$macrocall$1"] },
        { "name": "entry_body_bib$subexpression$1$macrocall$4", "symbols": ["bib_content"] },
        {
            "name": "entry_body_bib$subexpression$1$macrocall$3",
            "symbols": [brace_l, "_", "entry_body_bib$subexpression$1$macrocall$4", "_", brace_r],
            "postprocess": function (data) {
                return data[2];
            }
        },
        { "name": "entry_body_bib$subexpression$1", "symbols": ["entry_body_bib$subexpression$1$macrocall$3"] },
        {
            "name": "entry_body_bib",
            "symbols": ["entry_body_bib$subexpression$1"],
            "postprocess": function (data) {
                return data[0][0][0];
            }
        },
        { "name": "bib_content$ebnf$1", "symbols": [] },
        { "name": "bib_content$ebnf$1$subexpression$1", "symbols": ["keyval", "_", comma, "_"] },
        {
            "name": "bib_content$ebnf$1",
            "symbols": ["bib_content$ebnf$1", "bib_content$ebnf$1$subexpression$1"],
            "postprocess": function arrpush(d) {
                return d[0].concat([d[1]]);
            }
        },
        { "name": "bib_content$ebnf$2$subexpression$1", "symbols": ["_", comma] },
        { "name": "bib_content$ebnf$2", "symbols": ["bib_content$ebnf$2$subexpression$1"], "postprocess": id },
        {
            "name": "bib_content$ebnf$2", "symbols": [], "postprocess": function () {
                return undefined;
            }
        },
        {
            "name": "bib_content",
            "symbols": ["key_string", "_", comma, "_", "bib_content$ebnf$1", "keyval", "bib_content$ebnf$2"],
            "postprocess": function (data) {
                var obj = {
                    _id: data[0],
                    fields: []
                };
                var keyvals = data[4];
                for (var kv = 0; kv < keyvals.length; kv++) {
                    obj.fields.push(keyvals[kv][0]);
                }
                obj.fields.push(data[5]);
                return obj;
            }
        },
        {
            "name": "bib_entry",
            "symbols": [entry_type_bib, "_", "entry_body_bib"],
            "postprocess": function (data) {
                var obj = {
                    _id: data[2]._id
                };
                obj["@type"] = data[0].string;
                obj.fields = {};
                var keyvals = data[2].fields;
                for (var kv = 0; kv < keyvals.length; kv++) {
                    addToObj(obj, keyvals[kv]);
                }
                return obj;
            }
        },
        {
            "name": "string_entry",
            "symbols": [entry_type_string, "_", "entry_body_string"],
            "postprocess": function (data) {
                return { type: "string", data: data[2] };
            }
        },
        {
            "name": "preamble_entry",
            "symbols": [entry_type_preamble, "_", "entry_body_comment"],
            "postprocess": function (data) {
                return { type: "preamble", data: data[2] };
            }
        },
        {
            "name": "comment_entry",
            "symbols": [entry_type_comment, "_", "entry_body_comment"],
            "postprocess": function (data) {
                return { type: "comment", data: data[2] };
            }
        },
        {
            "name": "keyval",
            "symbols": ["key_string", "_", eq, "_", "value_string"],
            "postprocess": function (data) {
                return { type: "keyval", key: data[0], value: data[4] };
            }
        },
        { "name": "braced_string$ebnf$1", "symbols": [] },
        { "name": "braced_string$ebnf$1$subexpression$1", "symbols": ["non_brace"] },
        { "name": "braced_string$ebnf$1$subexpression$1", "symbols": ["braced_string"] },
        {
            "name": "braced_string$ebnf$1",
            "symbols": ["braced_string$ebnf$1", "braced_string$ebnf$1$subexpression$1"],
            "postprocess": function arrpush(d) {
                return d[0].concat([d[1]]);
            }
        },
        {
            "name": "braced_string",
            "symbols": [brace_l, "braced_string$ebnf$1", brace_r],
            "postprocess": function (data) {
                var tkz = [];
                for (var i in data[1])
                    tkz.push(data[1][i][0]);
                return { type: "braced", data: tkz };
            }
        },
        { "name": "quoted_string$ebnf$1", "symbols": [] },
        { "name": "quoted_string$ebnf$1$subexpression$1", "symbols": ["escaped_quote"] },
        { "name": "quoted_string$ebnf$1$subexpression$1", "symbols": ["non_quote_non_brace"] },
        { "name": "quoted_string$ebnf$1$subexpression$1", "symbols": ["braced_string"] },
        {
            "name": "quoted_string$ebnf$1",
            "symbols": ["quoted_string$ebnf$1", "quoted_string$ebnf$1$subexpression$1"],
            "postprocess": function arrpush(d) {
                return d[0].concat([d[1]]);
            }
        },
        {
            "name": "quoted_string",
            "symbols": [quote_dbl, "quoted_string$ebnf$1", quote_dbl],
            "postprocess": function (data) {
                var tks = [];
                for (var i in data[1])
                    tks.push(data[1][i][0]);
                return { type: "quotedstring", data: tks };
            }
        },
        { "name": "escaped_quote", "symbols": [esc, quote_dbl] },
        { "name": "non_quote_non_brace$subexpression$1", "symbols": [tok_id] },
        { "name": "non_quote_non_brace$subexpression$1", "symbols": [entry_type_bib] },
        { "name": "non_quote_non_brace$subexpression$1", "symbols": [entry_type_string] },
        { "name": "non_quote_non_brace$subexpression$1", "symbols": [entry_type_preamble] },
        { "name": "non_quote_non_brace$subexpression$1", "symbols": [entry_type_comment] },
        { "name": "non_quote_non_brace$subexpression$1", "symbols": [ws] },
        { "name": "non_quote_non_brace$subexpression$1", "symbols": [num] },
        { "name": "non_quote_non_brace$subexpression$1", "symbols": [pound] },
        { "name": "non_quote_non_brace$subexpression$1", "symbols": [eq] },
        { "name": "non_quote_non_brace$subexpression$1", "symbols": [esc] },
        { "name": "non_quote_non_brace$subexpression$1", "symbols": [paren_l] },
        { "name": "non_quote_non_brace$subexpression$1", "symbols": [paren_r] },
        { "name": "non_quote_non_brace$subexpression$1", "symbols": [comma] },
        { "name": "non_quote_non_brace", "symbols": ["non_quote_non_brace$subexpression$1"] },
        { "name": "key_string$ebnf$1", "symbols": ["stringreftoken"] },
        {
            "name": "key_string$ebnf$1",
            "symbols": ["key_string$ebnf$1", "stringreftoken"],
            "postprocess": function arrpush(d) {
                return d[0].concat([d[1]]);
            }
        },
        {
            "name": "key_string", "symbols": ["key_string$ebnf$1"], "postprocess": function (data) {
                return joinTokens(data[0]).toLowerCase();
            }
        },
        { "name": "value_string$subexpression$1$ebnf$1", "symbols": [] },
        {
            "name": "value_string$subexpression$1$ebnf$1$subexpression$1",
            "symbols": ["_", pound, "_", "quoted_string_or_ref"]
        },
        {
            "name": "value_string$subexpression$1$ebnf$1",
            "symbols": ["value_string$subexpression$1$ebnf$1", "value_string$subexpression$1$ebnf$1$subexpression$1"],
            "postprocess": function arrpush(d) {
                return d[0].concat([d[1]]);
            }
        },
        {
            "name": "value_string$subexpression$1",
            "symbols": ["quoted_string_or_ref", "value_string$subexpression$1$ebnf$1"]
        },
        { "name": "value_string$subexpression$1", "symbols": ["braced_string"] },
        {
            "name": "value_string",
            "symbols": ["value_string$subexpression$1"],
            "postprocess": function (data) {
                var match = data[0];
                if (match.length === 2) {
                    var tokenz = [];
                    tokenz.push(match[0]);
                    for (var i = 0; i < match[1].length; i++)
                        tokenz.push(match[1][i][3]);
                    return { type: "quotedstringwrapper", data: tokenz };
                }
                else if (match[0].type === "braced")
                    return { type: "bracedstringwrapper", data: match[0].data };
                else
                    throw new Error("Don't know how to handle value " + JSON.stringify(match[0]));
            }
        },
        { "name": "quoted_string_or_ref$subexpression$1", "symbols": ["quoted_string"] },
        { "name": "quoted_string_or_ref$subexpression$1", "symbols": ["string_ref"] },
        { "name": "quoted_string_or_ref$subexpression$1", "symbols": [num] },
        {
            "name": "quoted_string_or_ref",
            "symbols": ["quoted_string_or_ref$subexpression$1"],
            "postprocess": function (data) {
                if (data[0][0].type === "quotedstring")
                    return data[0][0];
                else {
                    return data[0][0];
                }
            }
        },
        { "name": "string_ref$subexpression$1$ebnf$1", "symbols": [] },
        {
            "name": "string_ref$subexpression$1$ebnf$1",
            "symbols": ["string_ref$subexpression$1$ebnf$1", "stringreftoken"],
            "postprocess": function arrpush(d) {
                return d[0].concat([d[1]]);
            }
        },
        {
            "name": "string_ref$subexpression$1",
            "symbols": ["stringreftoken_n_num", "string_ref$subexpression$1$ebnf$1"]
        },
        {
            "name": "string_ref",
            "symbols": ["string_ref$subexpression$1"],
            "postprocess": function (data) {
                var str = data[0][0] + joinTokens(data[0][1]);
                return { stringref: str };
            }
        },
        { "name": "stringreftoken$subexpression$1", "symbols": [esc] },
        { "name": "stringreftoken$subexpression$1", "symbols": [paren_l] },
        { "name": "stringreftoken$subexpression$1", "symbols": [paren_r] },
        { "name": "stringreftoken$subexpression$1", "symbols": [tok_id] },
        { "name": "stringreftoken$subexpression$1", "symbols": [num] },
        { "name": "stringreftoken$subexpression$1", "symbols": [entry_type_bib] },
        { "name": "stringreftoken$subexpression$1", "symbols": [entry_type_string] },
        { "name": "stringreftoken$subexpression$1", "symbols": [entry_type_preamble] },
        { "name": "stringreftoken$subexpression$1", "symbols": [entry_type_comment] },
        {
            "name": "stringreftoken",
            "symbols": ["stringreftoken$subexpression$1"],
            "postprocess": function (data) {
                if (typeof data[0][0] === "object") {
                    if (!data[0][0].string)
                        throw new Error("Expected " + data[0] + "to have a 'string' field");
                    return data[0][0].string;
                }
                else {
                    if ((!(typeof data[0][0] === "string" || typeof data[0][0] === "number")))
                        throw new Error("Expected " + data[0][0] + " to be a string");
                    return data[0][0];
                }
            }
        },
        { "name": "stringreftoken_n_num$subexpression$1", "symbols": [esc] },
        { "name": "stringreftoken_n_num$subexpression$1", "symbols": [paren_l] },
        { "name": "stringreftoken_n_num$subexpression$1", "symbols": [paren_r] },
        { "name": "stringreftoken_n_num$subexpression$1", "symbols": [tok_id] },
        { "name": "stringreftoken_n_num$subexpression$1", "symbols": [entry_type_bib] },
        { "name": "stringreftoken_n_num$subexpression$1", "symbols": [entry_type_string] },
        { "name": "stringreftoken_n_num$subexpression$1", "symbols": [entry_type_preamble] },
        { "name": "stringreftoken_n_num$subexpression$1", "symbols": [entry_type_comment] },
        {
            "name": "stringreftoken_n_num",
            "symbols": ["stringreftoken_n_num$subexpression$1"],
            "postprocess": function (data) {
                if (typeof data[0][0] === "object") {
                    if (!data[0][0].string)
                        throw new Error("Expected " + data[0] + "to have a 'string' field");
                    return data[0][0].string;
                }
                else {
                    if ((!(typeof data[0][0] === "string" || typeof data[0][0] === "number")))
                        throw new Error("Expected " + data[0][0] + " to be a string");
                    return data[0][0];
                }
            }
        },
        { "name": "non_brace$subexpression$1", "symbols": [esc] },
        { "name": "non_brace$subexpression$1", "symbols": [paren_l] },
        { "name": "non_brace$subexpression$1", "symbols": [paren_r] },
        { "name": "non_brace$subexpression$1", "symbols": [tok_id] },
        { "name": "non_brace$subexpression$1", "symbols": [quote_dbl] },
        { "name": "non_brace$subexpression$1", "symbols": [ws] },
        { "name": "non_brace$subexpression$1", "symbols": [num] },
        { "name": "non_brace$subexpression$1", "symbols": [comma] },
        { "name": "non_brace$subexpression$1", "symbols": [entry_type_bib] },
        { "name": "non_brace$subexpression$1", "symbols": [entry_type_string] },
        { "name": "non_brace$subexpression$1", "symbols": [entry_type_preamble] },
        { "name": "non_brace$subexpression$1", "symbols": [entry_type_comment] },
        { "name": "non_brace$subexpression$1", "symbols": [pound] },
        { "name": "non_brace$subexpression$1", "symbols": [eq] },
        {
            "name": "non_brace",
            "symbols": ["non_brace$subexpression$1"],
            "postprocess": function (data) {
                return data[0][0];
            }
        },
        { "name": "non_bracket$subexpression$1", "symbols": [esc] },
        { "name": "non_bracket$subexpression$1", "symbols": [tok_id] },
        { "name": "non_bracket$subexpression$1", "symbols": [quote_dbl] },
        { "name": "non_bracket$subexpression$1", "symbols": [ws] },
        { "name": "non_bracket$subexpression$1", "symbols": [num] },
        { "name": "non_bracket$subexpression$1", "symbols": [comma] },
        { "name": "non_bracket$subexpression$1", "symbols": [entry_type_bib] },
        { "name": "non_bracket$subexpression$1", "symbols": [entry_type_string] },
        { "name": "non_bracket$subexpression$1", "symbols": [entry_type_preamble] },
        { "name": "non_bracket$subexpression$1", "symbols": [entry_type_comment] },
        { "name": "non_bracket$subexpression$1", "symbols": [pound] },
        { "name": "non_bracket$subexpression$1", "symbols": [eq] },
        {
            "name": "non_bracket",
            "symbols": ["non_bracket$subexpression$1"],
            "postprocess": function (data) {
                return data[0][0];
            }
        },
        { "name": "non_entry$ebnf$1$subexpression$1", "symbols": ["escaped_entry"] },
        { "name": "non_entry$ebnf$1$subexpression$1", "symbols": ["escaped_escape"] },
        { "name": "non_entry$ebnf$1$subexpression$1", "symbols": ["escaped_non_esc_outside_entry"] },
        { "name": "non_entry$ebnf$1$subexpression$1", "symbols": ["non_esc_outside_entry"] },
        { "name": "non_entry$ebnf$1", "symbols": ["non_entry$ebnf$1$subexpression$1"] },
        { "name": "non_entry$ebnf$1$subexpression$2", "symbols": ["escaped_entry"] },
        { "name": "non_entry$ebnf$1$subexpression$2", "symbols": ["escaped_escape"] },
        { "name": "non_entry$ebnf$1$subexpression$2", "symbols": ["escaped_non_esc_outside_entry"] },
        { "name": "non_entry$ebnf$1$subexpression$2", "symbols": ["non_esc_outside_entry"] },
        {
            "name": "non_entry$ebnf$1",
            "symbols": ["non_entry$ebnf$1", "non_entry$ebnf$1$subexpression$2"],
            "postprocess": function arrpush(d) {
                return d[0].concat([d[1]]);
            }
        },
        {
            "name": "non_entry", "symbols": ["non_entry$ebnf$1"], "postprocess": function (data) {
                var tokens = [];
                for (var Ti = 0; Ti < data[0].length; Ti++)
                    tokens.push(data[0][Ti][0]);
                return tokens;
            }
        },
        {
            "name": "escaped_escape", "symbols": [esc, esc], "postprocess": function () {
                return "\\";
            }
        },
        {
            "name": "escaped_entry", "symbols": [esc, "entry_decl"], "postprocess": function (data) {
                return { type: "escapedEntry", data: data[1] };
            }
        },
        {
            "name": "escaped_non_esc_outside_entry",
            "symbols": [esc, "non_esc_outside_entry"],
            "postprocess": function (data) {
                return data;
            }
        },
        { "name": "non_esc_outside_entry$subexpression$1", "symbols": [tok_id] },
        { "name": "non_esc_outside_entry$subexpression$1", "symbols": [ws] },
        { "name": "non_esc_outside_entry$subexpression$1", "symbols": [num] },
        { "name": "non_esc_outside_entry$subexpression$1", "symbols": [pound] },
        { "name": "non_esc_outside_entry$subexpression$1", "symbols": [eq] },
        { "name": "non_esc_outside_entry$subexpression$1", "symbols": [paren_l] },
        { "name": "non_esc_outside_entry$subexpression$1", "symbols": [paren_r] },
        { "name": "non_esc_outside_entry$subexpression$1", "symbols": [brace_l] },
        { "name": "non_esc_outside_entry$subexpression$1", "symbols": [brace_r] },
        { "name": "non_esc_outside_entry$subexpression$1", "symbols": [quote_dbl] },
        { "name": "non_esc_outside_entry$subexpression$1", "symbols": [comma] },
        {
            "name": "non_esc_outside_entry",
            "symbols": ["non_esc_outside_entry$subexpression$1"],
            "postprocess": function (data) {
                return data[0][0];
            }
        }
    ],
    ParserStart: "main"
};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Token_1 = __webpack_require__(14);
var WhitespaceToken_1 = __webpack_require__(15);
var NumericToken_1 = __webpack_require__(16);
var IdToken_1 = __webpack_require__(22);
var BibBlockTypes_1 = __webpack_require__(23);
var Lexer = (function () {
    function Lexer(string) {
        this.str = string;
        this.len = string.length;
        this.pos = 0;
    }
    Lexer.prototype.getStringUntilNonEscapedChar = function (terminalRegex) {
        var chars = [];
        for (var i = this.pos; i < this.len + 1; i++) {
            this.pos = i;
            if (this.str.charAt(i) == "\\" && this.str.charAt(i + 1).match(terminalRegex)) {
                i++;
                this.pos = i;
            }
            else if (this.str.charAt(i).match(terminalRegex)) {
                break;
            }
            chars.push(this.str.charAt(i));
        }
        return chars.join("");
    };
    Lexer.prototype.readTokens = function () {
        var tokens = [];
        var nextToken;
        while (nextToken = this.readNextToken())
            tokens.push(nextToken);
        return tokens;
    };
    Lexer.prototype.readNextToken = function () {
        if (this.pos >= this.str.length)
            return undefined;
        var currentChar = this.str.charAt(this.pos);
        if (WhitespaceToken_1.isSingleWhiteSpaceCharacter(currentChar))
            return this.eatWhiteSpace();
        else if (Token_1.isSpecialChar(currentChar)) {
            return this.eatSpecialChars(currentChar);
        }
        else if (NumericToken_1.isNum(currentChar)) {
            return this.eatNumericString(currentChar);
        }
        else {
            return this.eatIdString();
        }
    };
    Lexer.prototype.eatIdString = function () {
        var chars = [];
        var pos2 = this.pos;
        for (var i = pos2; i < this.len + 1; i++) {
            this.pos = i;
            var charAtI = this.str.charAt(i);
            if (!IdToken_1.isIdChar(charAtI)) {
                break;
            }
            else {
                chars.push(charAtI);
            }
        }
        return IdToken_1.newIdToken(chars.join("").trim());
    };
    Lexer.prototype.eatNumericString = function (startAt) {
        var nums = [startAt];
        var nextPos = this.pos + 1;
        for (var newPos = nextPos; newPos < this.len + 1; newPos++) {
            this.pos = newPos;
            var newChar = this.str.charAt(newPos);
            if (NumericToken_1.isNum(newChar))
                nums.push(newChar);
            else
                break;
        }
        var numericString = nums.join("");
        if (nums[0] === "0")
            return NumericToken_1.newNumber(numericString);
        else {
            var number = Number.parseInt(numericString);
            return Number.isFinite(number) ? number : NumericToken_1.newNumber(numericString);
        }
    };
    Lexer.prototype.eatSpecialChars = function (startAt) {
        this.pos++;
        if (startAt === "@") {
            var type = this.getStringUntilNonEscapedChar("{").trim().toLowerCase();
            if (BibBlockTypes_1.isBibType(type))
                return Token_1.newToken(BibBlockTypes_1.bibTypes[type], type);
            else
                return Token_1.newToken("@bib", type);
        }
        return startAt;
    };
    Lexer.prototype.eatWhiteSpace = function () {
        var chars = [];
        while (this.pos < this.len + 1) {
            var c = this.str.charAt(this.pos);
            if (WhitespaceToken_1.isSingleWhiteSpaceCharacter(c)) {
                chars.push(c);
                this.pos++;
            }
            else
                break;
        }
        return WhitespaceToken_1.newWhitespace(chars.join(""));
    };
    return Lexer;
}());
exports.default = Lexer;


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Token_1 = __webpack_require__(14);
var WhitespaceToken_1 = __webpack_require__(15);
var NumericToken_1 = __webpack_require__(16);
function newIdToken(string) {
    return {
        type: "id",
        string: string
    };
}
exports.newIdToken = newIdToken;
function isIdToken(string) {
    return string.type === "id" && typeof string.string === "string";
}
exports.isIdToken = isIdToken;
function isIdChar(c) {
    return !(Token_1.isSpecialChar(c) || NumericToken_1.isNum(c) || WhitespaceToken_1.isSingleWhiteSpaceCharacter(c));
}
exports.isIdChar = isIdChar;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.bibTypes = {
    string: "@string",
    preamble: "@preamble",
    comment: "@comment",
    bib: "@bib"
};
exports.isBibType = function (c) {
    return exports.bibTypes.hasOwnProperty(c);
};


/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// index.js